/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

export default {
  presence: {
    batcherWait: 50,
    batcherMaxCalls: 50,
    batcherMaxWait: 150
  }
};
